// removed by extract-text-webpack-plugin
module.exports = {"bioContainer":"_2P0QKXIqUXvHDOYoRbjk1Z","bio":"_1bwSxomHGB1B8TbwC0V5q","bioContent":"_3JrMSVTTH_PWG51_jXGy6A","skillsContainer":"_2ljZs-4nKgoAorXxJxqda5","skillsVisibilitySensor":"_1BXS4n84a_Lvl_aK9q4cQG","leisurePic":"_2v4nfrXeW1HDzMaiwMd2YC"};


/*****************
 ** WEBPACK FOOTER
 ** ./about.module.scss
 ** module id = 1388
 ** module chunks = 0
 **/